export const firebaseConfig = {
	apiKey: "AIzaSyCNEYgGB80q1NWpfRB9LJ8m873P4uR15xg",
	authDomain: "advanced-todo-production.firebaseapp.com",
	projectId: "advanced-todo-production",
	storageBucket: "advanced-todo-production.appspot.com",
	messagingSenderId: "552260669744",
	appId: "1:552260669744:web:79cac0fa99e5784f3a78f5",
	measurementId: "G-Y84DHSLE36"
};
